<template>
  <div class="ui right aligned container">
    <button @click="modal=true" class="ui primary icon button">Add</button>
    <button @click="refresh" class="ui primary icon button"><i class="sync icon"></i></button>

    <vuetable ref="vuetable"
              api-url="/admin/invitations"
              :sort-order="sortOrder"
              :fields="fields"
              @vuetable:pagination-data="onPaginationData"
    >
      <template scope="props" slot="actions">
        <i @click="edit(props.rowData)" class="edit link icon"></i>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

    <Modal v-model="modal">
      <template slot="title">
        生成邀请码
      </template>
      <form class="ui form">
        <div class="field">
          <label>邀请码</label>
          <input name="code" type="text" v-model="invitation.code">
        </div>
        <div class="field">
          <label>邀请上限</label>
          <input name="limit" type="number" min="0" v-model="invitation.limit">
        </div>
        <div class="field">
          <label>过期时间</label>
          <date-picker format="YYYY-MM-DD HH:mm:ss" type="datetime" v-model="invitation.expire"></date-picker>
        </div>
      </form>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button">提交</div>
      </template>
    </Modal>

    <Modal v-model="show">
      <template slot="title">
        更新邀请码
      </template>
      <form class="ui form">
        <div class="field">
          <label>邀请码</label>
          <input name="code" type="text" v-model="invitation.code" readonly>
        </div>
        <div class="field">
          <label>邀请上限</label>
          <input name="limit" type="number" min="0" v-model="invitation.limit">
        </div>
        <div class="field">
          <label>过期时间</label>
          <date-picker format="YYYY-MM-DD HH:mm:ss" type="datetime" v-model="invitation.expire"></date-picker>
        </div>
      </form>
      <template slot="actions">
        <div @click="show=false" class="ui cancel button">取消</div>
        <div @click="update" class="ui positive button">更新</div>
      </template>
    </Modal>

  </div>
</template>

<script>
import axios from 'axios'
import Vuetable from '../../table/Vuetable.vue'
import VuetablePagination from '../../table/VuetablePagination.vue'
import Modal from '../../components/Modal'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'InvitationAdmin',
  components: {
    Vuetable,
    VuetablePagination,
    DatePicker,
    Modal,
  },
  data () {
    return {
      modal: false,
      show: false,
      invitation: {
        code: '',
        expire: '',
        limit: 1,
      },
      sortOrder: [
        {
          field: 'id',
          direction: 'desc'
        }
      ],
      fields: [
        { name: 'id', title: 'ID' },
        { name: 'code', title: '邀请码' },
        { name: 'creator.username', title: '创建者' },
        { name: 'limit', title: '邀请上限' },
        { name: 'count', title: '使用数量' },
        { name: 'time', title: '创建时间', callback: 'date' },
        { name: 'expire', title: '过期时间', callback: 'date' },
        {name: '__slot:actions', title: '操作'}
      ],
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    refresh: function () {
      this.$refs.vuetable.reload()
    },
    date: function (value) {
      return value ? new Date(value).toLocaleString() : 'Never'
    },
    onSubmit () {
      axios.post('/admin/invitations', this.invitation).then(() => {
        this.modal = false
        this.invitation.code = ''
        this.invitation.limit = 1
        this.invitation.expire = ''
        this.refresh()
      }).catch((error) => {
        this.$toasted.error(error.message)
      })
    },
    edit(item) {
      this.invitation = item
      this.show = true
    },
    update () {
      axios.put('/admin/invitations/' + this.invitation.id, this.invitation).then(() => {
        this.show = false
        this.invitation.code = ''
        this.invitation.limit = 1
        this.invitation.expire = ''
        this.refresh()
      }).catch((error) => {
        this.$toasted.error(error.message)
      })
    },
  }
}
</script>

<style scoped>

</style>
